/**
 * Posição do cursor em textarea (espelho de estilos), baseado em textarea-caret-position (MIT).
 */

const PROPERTIES = [
  "direction",
  "boxSizing",
  "width",
  "height",
  "overflowX",
  "overflowY",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderStyle",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "fontStretch",
  "fontSize",
  "fontSizeAdjust",
  "lineHeight",
  "fontFamily",
  "textAlign",
  "textTransform",
  "textIndent",
  "textDecoration",
  "letterSpacing",
  "wordSpacing",
  "tabSize",
  "MozTabSize",
];

function getCaretCoordinates(element, position) {
  if (typeof window === "undefined") {
    return { top: 0, left: 0, height: 16 };
  }

  const div = document.createElement("div");
  document.body.appendChild(div);

  const style = div.style;
  const computed = window.getComputedStyle(element);
  const isInput = element.nodeName === "INPUT";

  style.whiteSpace = "pre-wrap";
  if (!isInput) style.wordWrap = "break-word";
  style.position = "absolute";
  style.visibility = "hidden";

  PROPERTIES.forEach((prop) => {
    if (isInput && prop === "lineHeight") {
      if (computed.boxSizing === "border-box") {
        const height = parseInt(computed.height, 10);
        const outerHeight =
          parseInt(computed.paddingTop, 10) +
          parseInt(computed.paddingBottom, 10) +
          parseInt(computed.borderTopWidth, 10) +
          parseInt(computed.borderBottomWidth, 10);
        const targetHeight = outerHeight + parseInt(computed.lineHeight, 10);
        if (height > targetHeight) {
          style.lineHeight = `${height - outerHeight}px`;
        } else if (height === targetHeight) {
          style.lineHeight = computed.lineHeight;
        } else {
          style.lineHeight = "0";
        }
      } else {
        style.lineHeight = computed.height;
      }
    } else {
      style[prop] = computed[prop];
    }
  });

  if (window.mozInnerScreenX != null) {
    if (element.scrollHeight > parseInt(computed.height, 10)) {
      style.overflowY = "scroll";
    }
  } else {
    style.overflow = "hidden";
  }

  div.textContent = element.value.substring(0, position);
  if (isInput) {
    div.textContent = div.textContent.replace(/\s/g, "\u00a0");
  }

  const span = document.createElement("span");
  span.textContent = element.value.substring(position) || ".";
  div.appendChild(span);

  const coordinates = {
    top: span.offsetTop + parseInt(computed.borderTopWidth, 10),
    left: span.offsetLeft + parseInt(computed.borderLeftWidth, 10),
    height: parseInt(computed.lineHeight, 10) || parseInt(computed.fontSize, 10) || 16,
  };

  document.body.removeChild(div);
  return coordinates;
}

/**
 * Ponto em coordenadas de viewport para posicionar UI acima da seleção (usa índice médio).
 */
export function getTextareaSelectionAnchorViewport(textarea, selectionStart, selectionEnd) {
  if (!textarea || selectionStart == null || selectionEnd == null || selectionStart === selectionEnd) {
    return null;
  }
  const a = Math.min(selectionStart, selectionEnd);
  const b = Math.max(selectionStart, selectionEnd);
  const mid = Math.floor((a + b) / 2);
  const coords = getCaretCoordinates(textarea, mid);
  const rect = textarea.getBoundingClientRect();
  return {
    x: rect.left + coords.left - textarea.scrollLeft,
    y: rect.top + coords.top - textarea.scrollTop,
    lineHeight: coords.height,
  };
}
